import React from "react";
import { AppBar } from "@mui/material";
import { Toolbar } from "@mui/material";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { MenuItem } from "@mui/material";
import { Menu } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import "./../../assets/css/styles.css";
import { Grid } from "@mui/material";
import { Title, HeaderImage } from "../RequestForm/styles";

export const Header = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  // const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 992px)");
  // eslint-disable-next-line no-console

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleMenuClick = (pageUrl) => {
  //   history.push(pageUrl);
  //   setAnchorEl(null);
  // };

  // const handleButtonclick = (pageUrl) => {
  //   history.push(pageUrl);
  // };

  const menuItems = [
    { menuTitle: "Request Form", pageUrl: "/" },
    { menuTitle: "Documentation", pageUrl: "/Documentation" },
  ];

  return (
    <AppBar
      position="sticky"
      style={
        {
          // zIndex: 1501,
        }
      }
    >
      <Toolbar className="header">
        <Grid
          container
          spacing={0}
        >
          <Grid
            item
            xs={2}
            sm={0}
            md={0}
            lg={1}
            xl={2}
          />
          <Grid
            item
            xs={8}
            lg={10}
          >
            <div className="logo-wrapper">
              <a href="/">
                <HeaderImage
                  src="https://interoperability.healthfirst.org/images/HF_Logo2.png"
                  alt="Healthfirst Logo"
                />
              </a>
              <Title>Interoperability API Developer Portal</Title>
            </div>
          </Grid>
        </Grid>
        {isMobile ? (
          <div>
            <IconButton
              edge="start"
              className="menuButton"
              aria-label="menu"
              onClick={handleMenu}
              sx={{ color: "#474b55" }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menubar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: " right",
              }}
              open={open}
              onClose={() => setAnchorEl(null)}
              MenuListProps={{
                "aria-labelledby": "Menu",
              }}
            >
              {menuItems.map((menuItem) => {
                const { menuTitle, pageUrl } = menuItem;
                return (
                  <MenuItem
                    key={menuTitle}
                    component="a"
                    href={pageUrl}
                  >
                    {menuTitle}
                  </MenuItem>
                );
              })}
            </Menu>
          </div>
        ) : (
          <div className="headerOptions">
            <Link
              className="px-4"
              color="#000"
              to="/"
              underline="none"
              style={{ textDecoration: "none", color: "#008bbf" }}
            >
              Request Form
            </Link>
            <Link
              to="/Documentation"
              className="navLink"
              underline="hover"
              style={{ textDecoration: "none", color: "#008bbf" }}
            >
              Documentation
            </Link>
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
